/*eslint-disable*/
export const ALERT_ADD = 'ALERT_ADD';
export const ALERT_DISMISS = 'ALERT_DISMISS';

export const ALERT_TYPE = Object.freeze({
  ACCOUNT_RESTRICTED: 0,
  SERVER_UNAVAILABLE: 1,
  DL_NOT_UPLOADED: 2,
  // Provisionally comment out w. Joel's request
  BANK_LINK_NOT_ADDED: 3,
});

let nextAlertId = 0;
export const addAlert = (type) => {
  nextAlertId += 1;
  const createDate = new Date();
  return {
    type: ALERT_ADD,
    newAlert: {
      id: nextAlertId,
      type,
      createDate,
      visible: true,
    },
  };
};

export const dismissAlert = id => ({
  type: ALERT_DISMISS,
  id,
});



// WEBPACK FOOTER //
// ./src/actions/alerts.js